import { inject } from '@angular/core';

import { CasinoLazyBootstrapService } from './host-app/bootstrap/casino-lazy-bootstrap.service';
import { CasinoProductService } from './shared/services/casino-product.service';

/**
 * Route guard for initializing Casino-app bootstrap services in Host-App.
 * This guard takes care of running OnAppInit services which are specific to Casino-App since those will not be run by Host-App.
 */

export const casinoProductDeactivateGuard = () => {
    inject(CasinoProductService).deactivateCasino();
};

export const casinoProductActivateGuard = () => {
    inject(CasinoProductService).activateCasino();

    return inject(CasinoLazyBootstrapService).onCasinoAppInit();
};
